(() => {
    const LIMITS = {
      text: 15,
      textarea: 80,
      overrides: {
        // 'pet name': 15,
        // 'message': 80,
      },
    };

    const DONE = 'data-cl-limit';
    const COUNTER = 'cl-char-counter';

    const limitFor = (field) => {
      const option = field.closest('.customily_option');
      const label = option?.querySelector('.option_name')?.textContent || '';
      // Ô nào đặt Max length trong Customily thì nhãn có bộ đếm "(đã gõ|tối đa)",
      // vd "First Name (0|12)". Số đó THẮNG mặc định 15: bản cũ bỏ qua nó nên
      // template đặt 12 vẫn gõ được 15 ký tự (đo 17/09/2026, Couple Heart Car
      // Ornament ra "(15|12)"). Đọc lại mỗi lần vì bộ đếm có thể vẽ sau ô nhập.
      const counted = (option?.querySelector('.maxlength-counter')?.textContent || label).match(/\|\s*(\d+)\s*\)/);
      if (counted && Number(counted[1]) > 0) return Number(counted[1]);
      const key = label.replace(/\(\s*\d+\s*\|\s*\d+\s*\)/, '').replace('*', '').trim().toLowerCase();
      if (LIMITS.overrides[key]) return LIMITS.overrides[key];
      return field.tagName === 'TEXTAREA' ? LIMITS.textarea : LIMITS.text;
    };

    const attach = (field) => {
      if (field.hasAttribute(DONE)) return;
      const max = limitFor(field);
      field.setAttribute(DONE, String(max));
      field.setAttribute('maxlength', String(max));

      const counter = document.createElement('span');
      counter.className = COUNTER;
      field.insertAdjacentElement('afterend', counter);

      const render = () => {
        const max = limitFor(field);
        if (field.getAttribute(DONE) !== String(max)) {
          field.setAttribute(DONE, String(max));
          field.setAttribute('maxlength', String(max));
        }
        // Vue của Customily vẽ lại input sau mỗi lần gõ và xoá luôn thuộc tính
        // maxlength mình đặt (đã kiểm: gõ 26 ký tự vẫn lọt). Nên phải tự cắt
        // trong JS; dispatch 'input' để Vue đọc lại value mà cập nhật model,
        // không thì giá trị gửi lên giỏ vẫn là bản chưa cắt.
        if (field.value.length > max) {
          field.value = field.value.slice(0, max);
          field.setAttribute('maxlength', String(max));
          field.dispatchEvent(new Event('input', { bubbles: true }));
          return;
        }
        const used = field.value.length;
        counter.textContent = `${used}/${max}`;
        counter.classList.toggle('is-full', used >= max);
      };

      field.addEventListener('input', render);
      // Customily đổ lại giá trị cũ bằng JS (khách quay lại giỏ, đổi variant),
      // lúc đó không có sự kiện input nào — nghe thêm change cho chắc.
      field.addEventListener('change', render);
      render();
    };

    const scan = () => {
      document
        .querySelectorAll('#cl_optionsapp .cl-option-content input[type="text"], #cl_optionsapp .cl-option-content textarea')
        .forEach((f) => {
          const max = f.getAttribute(DONE);
          if (max && f.getAttribute('maxlength') !== max) f.setAttribute('maxlength', max);
        });
      document
        .querySelectorAll('#cl_optionsapp .cl-option-content input[type="text"], #cl_optionsapp .cl-option-content textarea')
        .forEach(attach);
    };

    const root = document.getElementById('customily-options') || document.body;
    new MutationObserver(scan).observe(root, { childList: true, subtree: true });
    scan();
  })();
